import React, { Component } from 'react';
import { Icon, Select } from 'antd';

import { observer, inject } from 'mobx-react';

import { isFunction } from 'lodash';

@inject('translationsStore', 'carsStore', 'filterStore')
@observer
export default class AlimentationFilter extends Component {
  keyStorage = `carFilter_alimentation`;

  constructor(props) {
    super(props);

    this.state = {
      selectedAlimentation: null,
      alimentationSelected: null
    };
  }

  componentDidMount() {
    if (this.props.carsStore.cars) {
      this.init(this.props.carsStore.cars);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status == !this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  init(cars) {
    this.setState({ cars }, () => {
      this.initAlimentation();
    });
  }

  initAlimentation = () => {
    const { translationsStore, filterStore } = this.props;
    const alimentations = this.props.carsStore.cars
      .map(car => car.alimentation)
      .filter((car, index, cars) => cars.indexOf(car) === index)
      .sort((a, b) => translationsStore.translate(`alimentation.${a}`).localeCompare(translationsStore.translate(`alimentation.${b}`)));
    this.setState({ alimentations });

    if (filterStore.appliedFiltersParameters && filterStore.appliedFiltersParameters.hasOwnProperty(this.keyStorage)) {
      const { selectedAlimentation } = filterStore.appliedFiltersParameters[this.keyStorage];
      this.setState({ selectedAlimentation });
    }
  };

  selectAlimentation = alimentation => {
    const { filterStore } = this.props;
    this.setState({ selectedAlimentation: alimentation });
    if (alimentation) {
      filterStore.add('carFilter_alimentation', car => car.alimentation === alimentation, undefined, { selectedAlimentation: alimentation });
    } else {
      filterStore.remove('carFilter_alimentation');
    }
  };

  removeAlimentation = () => {
    const { filterStore } = this.props;
    this.setState({ selectedAlimentation: null });
    filterStore.remove('carFilter_alimentation');
    filterStore.apply();
  };

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        selectedAlimentation: null
      });
    }
  };

  render() {
    const { selectedAlimentation } = this.state;
    const { translationsStore, carsStore } = this.props;
    return (
      <div id="alimentationFilter">
        <div className="filterTitle">
          {translationsStore.translate('carList.filters.filter.alimentation')}
          <span>
            {!!selectedAlimentation && (
              <span>
                {translationsStore.translate(`alimentation.${selectedAlimentation}`)}
                <Icon style={{ marginLeft: '5px' }} type="close-circle" onClick={this.removeAlimentation} />
              </span>
            )}
          </span>
        </div>
        <Select value={selectedAlimentation} getPopupContainer={() => document.getElementById('alimentationFilter')} onChange={this.selectAlimentation}>
          {carsStore.alimentations.map(alimentation => (
            <Select.Option value={alimentation} key={alimentation}>
              {translationsStore.translate(`alimentation.${alimentation}`)}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}
